import { ref } from 'vue'
import storage from './storage'

// 存储权限数据的响应式对象
const permissionList = ref([])

// 初始化权限数据
export const initPermissions = (permissions) => {
    permissionList.value = permissions
}

// 检查路由权限
export const checkRoutePermission = (routeName) => {

    if (!permissionList.value.length) return false
    const lowerRouteName = routeName.toLowerCase()
    return permissionList.value.some(permission => {
        // 如果是菜单类型权限，直接比对路由名称
        if (permission.ismenu === 1) {
            return permission.name.toLowerCase() === lowerRouteName
        }
        return false
    })
}

// 检查按钮/操作权限
export const checkActionPermission = (actionName) => {

    
    if (!permissionList.value.length) return false
    const lowerActionName = actionName.toLowerCase()

    return permissionList.value.some(permission => {
        // 如果不是菜单类型权限，则视为操作权限
        if (!permission.ismenu) {
            return permission.name.toLowerCase() === lowerActionName
        }
        return false
    })
}

// 获取所有有权限的路由名称
export const getAuthorizedRoutes = () => {
    return permissionList.value
}

// 获取所有有权限的操作名称
export const getAuthorizedActions = () => {
    return permissionList.value.filter(permission => !permission.ismenu)
}

// 清除权限数据
export const clearPermissions = () => {
    permissionList.value = []
}

export default {
    initPermissions,
    checkRoutePermission,
    checkActionPermission,
    getAuthorizedRoutes,
    getAuthorizedActions,
    clearPermissions
}